import { StackScreenProps } from "@react-navigation/stack";
import { FlatActionList, Page } from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { LlmStrategyFormValues } from "../../components/LlmStrategyForm";
import { useFormContext } from "react-hook-form";
import { View } from "react-native";
import { OpenAiDalleModels } from "./common";

export interface SelectOpenAiDalleModelScreenProps
  extends StackScreenProps<any, "SelectOpenAiDalleModelScreen"> {}

export const SelectOpenAiDalleModelScreen = ({
  navigation,
}: SelectOpenAiDalleModelScreenProps) => {
  const { t } = useTranslation("settings");
  const { getValues, setValue } = useFormContext<LlmStrategyFormValues>();
  const watchedKeyType = getValues("geminiConfig.geminiModel");
  const handleOnSelect = (code: string) => {
    setValue("geminiConfig.geminiModel", code, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    navigation.goBack();
  };
  return (
    <Page
      title={t("title.select_gemini_model")}
      secondaryTitle={t("title.select_gemini_model_secondary")}
    >
      <View>
        <FlatActionList
          items={OpenAiDalleModels.map((llmType) => ({
            key: llmType.value,
            title: llmType.label,
            subTitle: llmType.description,
            selected: llmType.value === watchedKeyType,
            onPress: () => {
              handleOnSelect(llmType.value);
            },
          }))}
        />
      </View>
    </Page>
  );
};
